import { drop, inkStroke, sabre, shards, slash, speed, sprite, star, swirl, target, blade } from '../kit';
import { C, mix, type Pix } from '../pix';
import { registerIcons } from '../store';

/**
 * ดาบขอเกี่ยวโคม (องครักษ์เสื้อแพร, yang): the guards' slim embroidered sabre with a gold guard and
 * a red-gold grip, cuts that bleed, the throne's gold.
 */

const HILT = '#f0c040';
const CUT = '#ffd890';

const guardSabre = (p: Pix, x0: number, y0: number, x1: number, y1: number, curve = -2) =>
  sabre(p, x0, y0, x1, y1, { hilt: HILT, w: 3, curve });

registerIcons('skill', {
  // A slicing cut that draws blood.
  'jy-cut': (p) => {
    slash(p, 14, 18, 12, -2.5, 0.1, CUT, 3);
    guardSabre(p, 5, 27, 26, 6);
    drop(p, 25, 20, 2.2, C.blood);
    drop(p, 21, 25, 1.6, C.blood);
  },
  // Two sabres crossed, cutting an X.
  'jy-cross': (p) => {
    guardSabre(p, 4, 27, 27, 4, -1.5);
    guardSabre(p, 27, 27, 4, 4, 1.5);
    star(p, 16, 15, 4, C.white);
    drop(p, 9, 21, 1.8, C.blood);
  },
  // A whirlwind of the blade.
  'jy-whirl': (p) => {
    swirl(p, 16, 16, 13, CUT, { arms: 2, turn: 4.6 });
    guardSabre(p, 9, 23, 25, 8, -1.5);
    for (const [x, y] of [
      [5, 10],
      [27, 21],
      [10, 28],
    ] as const)
      p.rect(x, y, 2, 2, C.blood);
  },
  // A lunge across the palace floor onto a marked man.
  'jy-lunge': (p) => {
    speed(
      p,
      11,
      [
        [13, 8],
        [18, 10],
        [23, 7],
      ],
      CUT,
    );
    guardSabre(p, 6, 21, 27, 12, -1.2);
    target(p, 25, 7, 3, C.white);
  },
  // An armour plate split by the blade, its scales flying.
  'jy-shatter': (p) => {
    sprite(
      p,
      3,
      4,
      [
        'ssssssssss',
        's.s.s.s.ss',
        'ssssssssss',
        'ss.s.s.s.s',
        'ssssssssss',
        's.s.s.s.ss',
        'ssssssssss',
        '.ssssssss.',
      ],
      { s: '#9aa6b8' },
      { k: 2 },
    );
    p.path(
      [
        [12, 4],
        [10, 10],
        [14, 13],
        [11, 19],
      ],
      C.ink,
      2,
    );
    shards(p, 12, 12, 10, '#c8d0dc', 5, 0.3);
    blade(p, 29, 2, 15, 11, { w: 3, col: C.steel, edge: C.white });
  },
  // An oath to the throne: the gold tablet of the guards, shining.
  'jy-oath': (p) => {
    for (let k = 0; k < 7; k++) {
      const a = -Math.PI + (k * Math.PI) / 6;
      p.line(17 + Math.cos(a) * 10, 13 + Math.sin(a) * 9, 17 + Math.cos(a) * 14, 13 + Math.sin(a) * 12, CUT);
    }
    p.rect(11, 7, 12, 19, C.gold);
    p.ell(17, 8, 6, 3, C.gold);
    p.rect(13, 10, 8, 12, mix(C.gold, C.ink, 0.3));
    p.rect(15, 12, 4, 4, C.seal);
    p.rect(16, 18, 2, 3, CUT);
    p.line(17, 26, 15, 30, C.seal).line(18, 26, 19, 30, C.seal);
  },
  // A heavy cut straight down, the blood of every wound it reopens running.
  'jy-execute': (p) => {
    inkStroke(
      p,
      [
        [3, 25],
        [29, 25],
      ],
      3,
      mix(C.blood, C.ink, 0.25),
    );
    sabre(p, 16, 2, 16, 23, { hilt: HILT, w: 5, curve: 1.5 });
    for (const x of [6, 10, 22, 26]) drop(p, x, 20 + (x % 3), 1.8, C.blood);
  },
  // The dragon-cleaving blade: a gold dragon coiling up the cut, three bites.
  'jy-dragon': (p) => {
    inkStroke(
      p,
      [
        [5, 27],
        [10, 20],
        [7, 14],
        [14, 8],
        [22, 9],
        [26, 4],
      ],
      5,
      C.gold,
    );
    p.path(
      [
        [5, 26],
        [10, 20],
        [7, 14],
        [14, 8],
        [22, 9],
      ],
      CUT,
    );
    sprite(p, 21, 3, ['..hh....', '.hhhhh..', 'hhehhhhh', 'hhhhhhw.', '.hhhh...', '..h.....'], {
      h: C.gold,
      e: C.seal,
      w: C.white,
    });
    p.line(28, 5, 30, 3, CUT);
    guardSabre(p, 13, 28, 27, 17, -1);
    for (let k = 0; k < 3; k++) p.line(20 + k * 3, 24, 22 + k * 3, 27, C.white);
  },
});
